export enum ECourseTabEnum {
  thumbnail = 'thumbnail',
  checkout = 'checkout',
  course = 'course',
  options = 'options',
  thank_you = 'thank_you',
}

export const tabLocoKeys: Record<ECourseTabEnum, string> = {
  [ECourseTabEnum.thumbnail]: 'dashboard.store.item.thumbnail',
  [ECourseTabEnum.checkout]: 'dashboard.store.item.checkout',
  [ECourseTabEnum.course]: 'dashboard.store.item.e_course.title',
  [ECourseTabEnum.options]: 'dashboard.store.item.options.title',
  [ECourseTabEnum.thank_you]: 'dashboard.store.item.thank_you_page',
}
